import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../components/ui/BiButton';

/** Why the last save was refused, then 取消 and the save. */
export const EditorFooter = memo(
  ({
    error,
    saveTitle,
    busy,
    canSave,
    onCancel,
    onSave,
  }: {
    error: string | null;
    saveTitle: string;
    busy: boolean;
    canSave: boolean;
    onCancel: () => void;
    onSave: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <>
        {error ? (
          <View style={{ paddingHorizontal: rpx(24), paddingTop: rpx(8) }}>
            <CardNotice tone="danger" text={error} />
          </View>
        ) : null}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: rpx(8),
            paddingHorizontal: rpx(24),
            paddingVertical: rpx(16),
            borderTopWidth: 1,
            borderTopColor: aiColors.border,
          }}
        >
          <BiButton title="取消" onPress={onCancel} />
          <BiButton
            title={saveTitle}
            tone="primary"
            loading={busy}
            disabled={!canSave}
            onPress={onSave}
          />
        </View>
      </>
    );
  },
);
